import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import { useSelector } from 'react-redux';

function OpuPatientsTable() {
  const borderRight = { borderRight: '1px solid rgba(224, 224, 224, 1)' };
  const { data } = useSelector((state) => state.dataAnalyticsReducer);
  const getCellData = (key, index) => {
    if (!data || !data[index]) {
      return 'N/A';
    }
    if (key.includes('summary')) {
      if (!data[index].summary) {
        return 'N/A';
      }

      if (
        data[index].summary[key.split('.')[1]] === null ||
        data[index].summary[key.split('.')[1]] === ''
      ) {
        return 'N/A';
      }
      return data[index].summary[key.split('.')[1]] ?? 'N/A';
    }
    if (data[index][key] === null || data[index][key] === '') {
      return 'N/A';
    }
    return data[index][key] ?? 'N/A';
  };
  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell
            colSpan={7}
            style={{
              fontWeight: 700,
              textAlign: 'center',
              ...borderRight,
            }}
          >
            PATIENT DETAILS
          </TableCell>
          <TableCell style={borderRight}></TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow>
          <TableCell style={{ fontWeight: 700 }}>Cycle Id</TableCell>
          <TableCell style={{ fontWeight: 700 }}>Patient Name</TableCell>
          <TableCell style={{ fontWeight: 700 }}>Patient ID</TableCell>
          <TableCell style={{ fontWeight: 700 }}>Patient Age</TableCell>
          <TableCell style={{ fontWeight: 700 }}>Treating Consultant</TableCell>
          <TableCell style={{ fontWeight: 700 }}>
            Oocyte Cycle (Self/OD)
          </TableCell>
          <TableCell
            style={{
              fontWeight: 700,
              ...borderRight,
            }}
          >
            Sperm Cycle (Self/DS)
          </TableCell>
          <TableCell
            style={{
              fontWeight: 700,
              ...borderRight,
            }}
          >
            MONTH
          </TableCell>
        </TableRow>

        <TableRow>
          <TableCell colSpan={7}>
            <div style={{ height: '20px' }}></div>
          </TableCell>
          <TableCell></TableCell>
        </TableRow>

        {data &&
          data.map((item, index) => (
            <TableRow key={index}>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('cycleId', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('patientName', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('upid', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('patientAge', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('summary.treatingDoctor', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('summary.sourceOfOocyte', index)}
                </div>
              </TableCell>
              <TableCell style={borderRight}>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('summary.sperm', index)}
                </div>
              </TableCell>
              <TableCell style={borderRight}></TableCell>
            </TableRow>
          ))}
      </TableBody>
    </Table>
  );
}

export default OpuPatientsTable;
